import { css } from "lit-element";

export const style = css`
	:host {
		--sw-dialog-simple-width: 80%;
		--sw-dialog-simple-height: 80%;
	}

	a {
		text-decoration: none;
		color: var(--app-primary);
	}

	h3 {
		margin-top: 0;
	}

	dialog-simple[small] {
		--sw-dialog-simple-width: 30%;
		--sw-dialog-simple-height: auto;
	}

	.page-container {
		padding: var(--sw-page-table-padding, 20px);
	}

	button-outlined {
		margin: 10px auto;
	}

	icon {
		display: block;
		height: 16px;
		width: 16px;
	}

	icon[app-red] path,
	icon[app-red] svg,
	icon[app-red] {
		color: var(--app-red);
		fill: var(--app-red);
	}
`;
